(function() {
  // Listen for form submissions
  document.addEventListener('submit', function(e) {
    const form = e.target;
    
    // Check if this is the modal form (adjust selector if needed)
    if (form.closest('[data-modal]') || form.classList.contains('modal-form')) {
      // Prevent default and handle with fetch
      e.preventDefault();
      
      // Submit the form via fetch
      fetch(form.action, {
        method: form.method,
        body: new FormData(form)
      })
      .then(response => {
        if (response.ok) {
          showSuccessNotification();
        }
      })
      .catch(err => console.error('Form submission error:', err));
    }
  }, true);

  function showSuccessNotification() {
    // Remove any existing notification
    const existing = document.querySelector('.success-notification-bar');
    if (existing) existing.remove();

    // Create notification
    const notification = document.createElement('div');
    notification.className = 'success-notification-bar';
    notification.innerHTML = `
      <div class="notification-content">
        <span>Thanks! You're on the list.</span>
        <button class="notification-close" aria-label="Close">×</button>
      </div>
    `;

    // Add styles
    if (!document.querySelector('#notification-styles')) {
      const style = document.createElement('style');
      style.id = 'notification-styles';
      style.textContent = `
        .success-notification-bar {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          background-color: #008060;
          color: white;
          padding: 16px 20px;
          z-index: 9999;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          animation: slideDown 0.3s ease-out;
        }
        
        @keyframes slideDown {
          from {
            transform: translateY(-100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        .notification-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          max-width: 1200px;
          margin: 0 auto;
          gap: 20px;
        }
        
        .notification-close {
          background: none;
          border: none;
          color: white;
          font-size: 24px;
          cursor: pointer;
          padding: 0;
          flex-shrink: 0;
          line-height: 1;
        }
        
        .notification-close:hover {
          opacity: 0.8;
        }
      `;
      document.head.appendChild(style);
    }

    // Insert at top of body
    document.body.insertBefore(notification, document.body.firstChild);

    // Close button
    notification.querySelector('.notification-close').addEventListener('click', () => {
      notification.remove();
    });

    // Auto-dismiss after 4 seconds
    setTimeout(() => {
      if (notification.parentNode) {
        notification.remove();
      }
    }, 4000);
  }
})();
